export const ORIGEM_NCA_LINK = 'nca_link';

/**
 * `transportadora` não aparece aqui de propósito: o servidor a resolve pelo uuid
 * do link e a injeta. O cliente não a conhece e não pode afirmá-la.
 */
export interface OnboardingNcaBaseMetadata extends Record<string, unknown> {
  origem: typeof ORIGEM_NCA_LINK;
}

export interface AutorizacaoVisualizadaInput {
  /** Ausente quando a taxa exibida é fixa, em reais. */
  percentualExibido?: number;
}

export interface TrackingSDKLike {
  track(eventName: string, metadata?: Record<string, unknown>): void;
}
